<template>
  <el-dialog
    ref="dialog"
    v-dialog-drag
    title="选择人员"
    :visible.sync="dialogVisible"
    :width="device == 'mobile' ? '90%' : '60%'"
    top="8vh"
    :before-close="handleClose"
    @open="openCallBack"
  >
    <el-scrollbar style="height: 550px">
      <el-tree
        v-if="showTree"
        ref="userTree"
        :data="userList"
        node-key="label"
        highlight-current
        :props="{ label: 'label' }"
        :default-expand-all="true"
        :default-checked-keys="userCheckedList"
        show-checkbox
        @current-change="currentChange"
      >
        <span slot-scope="{ node, data }">
          <i class="fa" :class="data.icon" style="margin-right: 10px"></i>
          <span class="treeNode">{{ node.label }}</span>
        </span>
      </el-tree>
    </el-scrollbar>
    <span slot="footer" class="dialog-footer">
      <el-button icon="el-icon-circle-close" @click="close">{{
        "取消"
      }}</el-button>
      <el-button
        icon="el-icon-circle-check"
        type="success"
        @click.native="saveAuth"
      >
        {{ "保存" }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import "zr-dialog/src/components/zr/dialog/dialog_drag";
import {
  getUserTree,
  doSaveRoleAuthUsers,
} from "@/api/framework/auth/roleAuth";
import { messageDuration } from "../../../../config/settings";

export default {
  name: "UserTree",
  props: {
    dialogVisible: {
      type: Boolean,
    },
    dialogData: {
      type: Object,
      default: () => {
        return { action: "add" };
      },
    },
  },
  data() {
    return {
      showTree: true,
      userList: [],
      userCheckedList: [],
    };
  },
  computed: {
    ...mapGetters({
      device: "settings/device",
    }),
  },
  async created() {
    await this.fetchUserTree();
  },
  methods: {
    currentChange(data) {
      this.$emit("current-change", data);
    },
    async saveAuth() {
      let users = [];
      let checkedNodes = this.$refs.userTree.getCheckedNodes();
      for (let i = 0; i < checkedNodes.length; i++) {
        var tag = checkedNodes[i].tag;
        var value = tag.split(",");
        if (value[0] != "dept") {
          users.push(value[1] + "," + value[3] + "," + value[4]);
        }
      }
      const res = await doSaveRoleAuthUsers({
        users: JSON.stringify(users),
        roleCode: this.dialogData.data.roleCode,
      });
      if (res.success) {
        this.$message.success({
          showClose: true,
          message: "保存成功!",
          duration: messageDuration,
        });
        this.close();
        this.$emit("openCallBack", { data: data });
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async fetchUserTree() {
      this.showTree = false;
      const res = await getUserTree({
        roleCode: this.dialogData.data.roleCode,
      });
      if (res.success) {
        this.userList = res.data;
        let userCheckedList = [];
        let stack = JSON.parse(JSON.stringify(this.userList)); // 深拷贝
        this.userCheckedList = this.treeToArray(stack, userCheckedList);
        this.userCheckedList = this.userCheckedList
          .filter((v) => v.checked)
          .map((value) => value.label);
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
      this.$nextTick(() => {
        this.showTree = true;
      });
    },
    specialTreeToNormalTree(tree) {
      let result = [];
      for (let i = 0, len = tree.length; i < len; i++) {
        const node = tree[i];
        let curNode = { ...node.nodeInfo };
        const children = node.children;
        if (children && children.length > 0) {
          curNode.children = this.specialTreeToNormalTree(children);
        }
        result.push(curNode);
      }
      return result;
    },
    treeToArray(treeList, newArr = []) {
      treeList.forEach((item) => {
        const { children } = item;
        if (children) {
          delete item.children;
          if (children.length) {
            newArr.push(item);
            return this.treeToArray(children, newArr);
          }
        }
        newArr.push(item);
      });
      return newArr;
    },
    handleClose(done) {
      this.close();
      done();
    },
    //窗口开启回调函数
    openCallBack() {
      if (this.dialogData.action === "edit") {
        this.mode = "edit";
      }
    },
    close() {
      this.dialogVisible = false;
      this.$emit("dialogVisibleChange", this.dialogVisible);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 20px;
  left: calc(50% - 20px);
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.el-button--mini {
  padding: 5px 10px;
  margin-left: 5px;
}

.el-steps--simple {
  cursor: pointer;
}

.simditor .simditor__body {
  overflow-y: scroll !important;
  min-height: 220px;
  max-height: 330px;
}
</style>
